
import Vue, { PropType } from 'vue';
import { CvAccordion, CvAccordionItem } from '@carbon/vue';
import { useStore as useColorManagementStore } from '@/stores/v2/colorsManagement';
import { useStore as useProductStore } from '@/stores/v2/product';
import { mapActions, mapState } from 'pinia';
import { ProductPrintPositionSetterType } from '@/setters/typings/common/ProductPrintPositionSetterType';
import ChevronDown16 from '@carbon/icons-vue/es/chevron--down/16';

import {
  PdpChoicesSetterType,
  PriceDetailsSetterType,
} from '@/setters/typings';

export default Vue.extend({
  components: {
    CvAccordion,
    CvAccordionItem,
    ChevronDown16,
  },
  props: {
    pricingData: {
      type: Object as PropType<PriceDetailsSetterType>,
      required: true,
    },
    pdpChoicesData: {
      type: Object as PropType<PdpChoicesSetterType>,
      required: true,
    },
    totalQuantity: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapState(useProductStore, ['unavailablePrintPositions', 'data']),
  },

  methods: {
    ...mapActions(useColorManagementStore, ['getPmsColorByPrintPositionId']),
    getNumberOfColours(position: ProductPrintPositionSetterType): string {
      const productPrintPosition = this.data.productPrintPositions.find(
        (p) => p.name === position.printPositionSAPCode
      );
      const technique = productPrintPosition?.printTechniques.find(
        (technique) => {
          return (
            technique.printTechnique.code === position.printTechniqueSAPCode
          );
        }
      );

      const finalResult = +position.numberOfColors || 0;
      const textToReturn = technique?.printTechnique.isFullColor
        ? `${this.$t('print-position.full-colour')}`
        : `${this.$tc('print-position.number-colours', finalResult, {
            number: finalResult,
          })}`;

      return textToReturn;
    },
    getPrintTechniqueSAPCode(position: ProductPrintPositionSetterType): string {
      const printPosition = this.unavailablePrintPositions.find(
        (p) => p.printPositionSAPCode === position.printPositionSAPCode
      );

      return printPosition?.technique.printTechniqueSAPCode as string;
    },
  },
});
